export const ariaLabelText = {
  drawerOpen: 'Open sidebar menu',
  drawerClose: 'Close sidebar menu',
};

export const errorText = {
  gmapKeyNotFound: 'API Key was not found',
  gmapCoordinatesNotFound: 'Coordinate was not found. Pls check data-coordinates attribute',
};

export const messages = {
  missingValue: {
    checkbox: 'Это поле обязательно к заполнению.',
    radio: 'Пожалуйста, выберите значение.',
    select: 'Пожалуйста, выберите значение.',
    'select-multiple': 'Выберите хотя бы одно значение.',
    default: 'Пожалуйста, заполните это поле.',
  },
  patternMismatch: {
    email: 'Пожалуйста, введите действительный адрес электронной почты.',
    url: 'Пожалуйста, введите URL.',
    number: 'Пожалуйста, введите номер',
    color: 'Пожалуйста, укажите следующий формат: #rrggbb',
    date: 'Используйте формат ГГГГ-ММ-ДД',
    time: 'Пожалуйста, используйте 24-часовой формат времени. 23:00',
    month: 'Используйте формат ГГГГ-ММ ',
    default: 'Пожалуйста, сопоставьте запрошенный формат.',
  },
  outOfRange: {
    over: 'Пожалуйста, выберите значение не более {max}.',
    under: 'Пожалуйста, выберите значение не меньше, чем {min}.',
  },
  wrongLength: {
    over: 'Минимальная длина  {maxLength}.',
    under: 'Увеличьте длину этого текста до {minLength} символов или более.',
  },
};
